import * as React from 'react';
import Svg, {Path} from 'react-native-svg';

interface IProps {
  size?: number;
}

function LocationMarkerErrorIconAramark({size = 74}: IProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 74 74" fill="none">
      <Path
        d="M62.696 37c0 14.19-11.504 25.694-25.695 25.694M62.696 37c0-14.191-11.504-25.695-25.695-25.695M62.696 37h-51.39m25.695 25.694c-14.19 0-25.694-11.504-25.694-25.694M37 62.694A39.313 39.313 0 0047.28 37 39.312 39.312 0 0037 11.305m0 51.39A39.313 39.313 0 0126.723 37a39.312 39.312 0 0110.278-25.695M11.307 37c0-14.191 11.503-25.695 25.694-25.695"
        stroke="#D23580"
        strokeWidth={1.92708}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default LocationMarkerErrorIconAramark;
